{
  "wordmark": {
    "subtitle": "Studio panel"
  },
  "fields": {
    "emailPlaceholder": "welcome@frameriver.ai",
    "passwordPlaceholder": "••••••••",
    "passwordMinPlaceholder": "At least 8 characters",
    "companyNamePlaceholder": "My studio"
  },
  "passwordVisibility": {
    "show": "Show password",
    "hide": "Hide password"
  },
  "theme": {
    "light": "Light theme",
    "dark": "Dark theme"
  },
  "locale": {
    "label": "Language",
    "switchToRu": "Switch to Russian",
    "switchToEn": "Switch to English",
    "ru": "RU",
    "en": "EN"
  },
  "mascots": {
    "login": {
      "eyebrow": "Welcome back",
      "title": "Back in the studio",
      "subtitle": "Sign in to continue working on frames, storyboards, and renders.",
      "features": ["Rendering", "Storyboards", "Team"]
    },
    "signup": {
      "eyebrow": "Getting started",
      "title": "Create your account",
      "subtitle": "Frama helps you assemble a team and launch your studio's first projects.",
      "features": ["Collaboration", "Roles", "Projects"]
    },
    "forgot": {
      "eyebrow": "No worries",
      "title": "Restore access",
      "subtitle": "Riv will guide you back to the studio panel.",
      "features": ["Support", "Security"]
    },
    "onboarding": {
      "eyebrow": "Welcome",
      "title": "Let's get started",
      "subtitle": "Create a company or accept an invitation to join production.",
      "features": ["Studios", "Invitations", "Projects"]
    },
    "invitation": {
      "eyebrow": "Invitation",
      "title": "The team is waiting",
      "subtitle": "Accept the invitation and join the studio workflow.",
      "features": ["Team", "Access", "Projects"]
    },
    "newCompany": {
      "eyebrow": "New studio",
      "title": "Your own company",
      "subtitle": "Create a company — you'll become the owner and can invite members.",
      "features": ["Owner", "Team", "Control"]
    },
    "oauth": {
      "eyebrow": "Claude / MCP",
      "title": "Connect an assistant",
      "subtitle": "Claude will work in Frame River with the same access as this login.",
      "features": ["Projects", "Prompts", "Tools"]
    }
  },
  "login": {
    "title": "Sign in",
    "eyebrow": "Welcome back",
    "heading": "Sign in to the studio",
    "subtitle": "Sign in to continue working on projects.",
    "forgotPassword": "Forgot password?",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "noAccount": "Don't have an account?",
    "signupLink": "Sign up"
  },
  "signup": {
    "title": "Sign up",
    "eyebrow": "Getting started",
    "heading": "Create an account",
    "subtitle": "A few steps — and you're in studio production.",
    "invitationBanner": "Invitation to join {{company}}. After signing up you'll join automatically.",
    "passwordConfirmation": "Confirm password",
    "firstNamePlaceholder": "Jane",
    "lastNamePlaceholder": "Doe",
    "submit": "Create account",
    "submitting": "Creating…",
    "hasAccount": "Already have an account?",
    "loginLink": "Sign in",
    "acceptTerms": "I accept the",
    "termsLink": "terms of service",
    "acceptPrivacy": "I accept the",
    "privacyLink": "privacy policy",
    "acceptOffer": "I accept the",
    "offerLink": "offer agreement"
  },
  "forgotPassword": {
    "title": "Password recovery",
    "eyebrow": "No worries",
    "heading": "Password recovery",
    "subtitle": "Enter your email and we'll send you a password reset link.",
    "submit": "Send link",
    "submitting": "Sending…",
    "backToLogin": "Back to sign in"
  },
  "checkEmail": {
    "title": "Confirm your email",
    "eyebrow": "Almost there",
    "heading": "Check your inbox",
    "subtitle": "We sent a confirmation link to {{email}}.",
    "subtitleNoEmail": "We sent a confirmation link to your address.",
    "resend": "Send again",
    "resending": "Sending…",
    "backToLogin": "Back to sign in"
  },
  "resetPassword": {
    "title": "New password",
    "eyebrow": "Almost there",
    "heading": "Set a new password",
    "subtitle": "Enter a new password for your account.",
    "passwordConfirmation": "Confirm password",
    "submit": "Save password",
    "submitting": "Saving…"
  },
  "onboarding": {
    "title": "Welcome",
    "eyebrow": "Welcome",
    "heading": "Where shall we start?",
    "subtitle": "Create a company or accept an invitation to join production.",
    "invitationsSection": "Invitations",
    "join": "Join",
    "decline": "Decline",
    "suspended": "Your access to “{{company}}” has been suspended by the company owner. Contact them to get back in.",
    "archived": "This company has been archived. Contact your platform manager to restore access.",
    "firstNamePlaceholder": "Jane",
    "lastNamePlaceholder": "Doe",
    "ownCompanySection": "Your own company",
    "ownCompanyDescription": "Create a new company and become its owner.",
    "createCompany": "Create company"
  },
  "newCompany": {
    "title": "New company",
    "eyebrow": "New studio",
    "heading": "Create a company",
    "subtitle": "You'll become the owner and can invite members.",
    "nameLabel": "Name",
    "submit": "Create company",
    "submitting": "Creating…",
    "offerAccept": "By creating a company you accept the terms of the",
    "offerLink": "offer agreement"
  },
  "acceptInvitation": {
    "title": "Company invitation",
    "eyebrow": "Invitation",
    "roleSubtitle": "Company role “{{role}}” for {{email}}.",
    "seesAllProjects": "Owners can see every project in the company.",
    "seesAllProjectsRoles": "Owners can see every project in the company. Project roles: {{list}}.",
    "alreadyAccepted": "This invitation has already been accepted.",
    "declined": "This invitation was declined.",
    "expired": "This invitation has expired.",
    "signInPrompt": "To accept the invitation, sign up or sign in with {{email}}.",
    "signUp": "Sign up",
    "signIn": "Sign in",
    "wrongEmail": "This invitation was sent to {{email}}. Sign in with that address to accept.",
    "firstNamePlaceholder": "Jane",
    "lastNamePlaceholder": "Doe",
    "joinCompany": "Join company"
  }
}
